function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 24 0 24 24 6.9757157 24 0 24"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Component",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5206\\u4EAB",
  transform: "translate(0.000000, -0.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "basic-/-share_outline-(Background/Mask)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.85699987,14.0699997 L14.1169996,17.6469994 C14.0479996,17.9219994 14,18.204 14,18.5 C14,20.4299999 15.5700001,22 17.5,22 C19.4299999,22 21,20.4299999 21,18.5 C21,16.5700001 19.4299999,15 17.5,15 C16.59,15 15.7669997,15.3580003 15.1429996,15.9300003 L8.88300037,12.3529997 C8.94600037,12.1059997 8.98600018,11.851 8.99100018,11.585 L15.1420002,8.06999969 C15.7670002,8.64199972 16.59,9 17.5,9 C19.4299999,9 21,7.42999995 21,5.5 C21,3.57000005 19.4299999,2 17.5,2 C15.5700001,2 14,3.57000005 14,5.5 C14,5.796 14.0479996,6.07800016 14.1169996,6.35300016 L8.43299961,9.60200024 C7.80799961,8.64000022 6.72899997,8 5.5,8 C3.57000005,8 2,9.57000005 2,11.5 C2,13.4299999 3.57000005,15 5.5,15 C6.41000003,15 7.23299986,14.6419997 7.85699987,14.0699997 Z M19,18.5 C19,19.327 18.327,20 17.5,20 C16.673,20 16,19.327 16,18.5 C16,17.673 16.673,17 17.5,17 C18.327,17 19,17.673 19,18.5 Z M19,5.5 C19,6.32700002 18.327,7 17.5,7 C16.673,7 16,6.32700002 16,5.5 C16,4.67299998 16.673,4 17.5,4 C18.327,4 19,4.67299998 19,5.5 Z M7,11.5 C7,12.327 6.32700002,13 5.5,13 C4.67299998,13 4,12.327 4,11.5 C4,10.673 4.67299998,10 5.5,10 C6.32700002,10 7,10.673 7,11.5 Z",
  fill: "#282C34",
  mask: "url(#mask-2)"
})));

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5206\u4EAB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7196e7a5.svg";
export { ForwardRef as ReactComponent };